(function() {
  function initProyectoExperiencias(root) {
    if (!root || root.dataset.proyectoExperienciasInitialized === 'true') return;

    root.dataset.proyectoExperienciasInitialized = 'true';

    var projectGrid = root.querySelector('[data-project-grid]');
    var videoGrid = root.querySelector('[data-project-video-grid]');
    var dynamicTitle = root.querySelector('[data-project-content-title]');
    var dynamicText = root.querySelector('[data-project-content-text]');

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-project-card]'));
    var videoCards = Array.prototype.slice.call(root.querySelectorAll('[data-project-video-card]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-project-filter]'));
    var modals = Array.prototype.slice.call(root.querySelectorAll('[data-project-modal]'));
    var openButtons = Array.prototype.slice.call(root.querySelectorAll('[data-project-open]'));
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-project-close]'));
    var imageButtons = Array.prototype.slice.call(root.querySelectorAll('[data-project-image]'));
    var players = Array.prototype.slice.call(root.querySelectorAll('[data-project-player]'));
    var emptyMessage = root.querySelector('[data-project-filter-empty]');
    var lightbox = root.querySelector('[data-project-lightbox]');
    var lightboxImage = root.querySelector('[data-project-lightbox-image]');
    var lightboxClose = root.querySelector('[data-project-lightbox-close]');
    var lightboxPrev = root.querySelector('[data-project-lightbox-prev]');
    var lightboxNext = root.querySelector('[data-project-lightbox-next]');

    var currentGalleryImages = [];
    var currentGalleryIndex = 0;
    var touchStartX = 0;
    var touchEndX = 0;

    function getCount(filterName) {
      if (filterName === 'all') return cards.length;

      if (filterName === 'video') {
        return videoCards.length;
      }

      return cards.filter(function(card) {
        return card.getAttribute('data-project-type') === filterName;
      }).length;
    }

    function setCount(name, value) {
      var count = root.querySelector('[data-project-count="' + name + '"]');

      if (count) {
        count.textContent = value;
      }
    }

    function syncCountsAndFilters() {
      filters.forEach(function(button) {
        var filterName = button.getAttribute('data-project-filter') || 'all';
        var count = getCount(filterName);

        setCount(filterName, count);

        if (filterName !== 'all') {
          button.hidden = count === 0;
        }
      });
    }

    function cleanShopifyValue(value) {
      if (!value) return '';

      var cleaned = String(value)
        .replace(/<!--[\s\S]*?-->/g, '')
        .replace(/&lt;!--[\s\S]*?--&gt;/g, '')
        .trim();

      var temporaryElement = document.createElement('div');
      temporaryElement.innerHTML = cleaned;

      return (temporaryElement.textContent || temporaryElement.innerText || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function updateContentTitle(filterName) {
      var activeButton = filters.find(function(button) {
        return button.getAttribute('data-project-filter') === filterName;
      });

      var defaultButton = filters.find(function(button) {
        return button.getAttribute('data-project-filter') === 'all';
      });

      if (!activeButton && !defaultButton) return;

      var newTitle = activeButton ? activeButton.getAttribute('data-project-title') : '';
      var defaultTitle = defaultButton ? defaultButton.getAttribute('data-project-title') : '';

      var newText = activeButton ? activeButton.getAttribute('data-project-text') : '';
      var defaultText = defaultButton ? defaultButton.getAttribute('data-project-text') : '';

      newTitle = cleanShopifyValue(newTitle);
      defaultTitle = cleanShopifyValue(defaultTitle);

      newText = cleanShopifyValue(newText);
      defaultText = cleanShopifyValue(defaultText);

      if (!newTitle) {
        newTitle = defaultTitle;
      }

      if (!newText) {
        newText = defaultText;
      }

      if (dynamicTitle && newTitle) {
        dynamicTitle.textContent = newTitle;
      }

      if (dynamicText) {
        dynamicText.textContent = newText || '';
      }
    }

    function pauseMediaInside(container) {
      if (!container) return;

      var videos = Array.prototype.slice.call(container.querySelectorAll('video'));

      videos.forEach(function(video) {
        try {
          video.pause();
        } catch(error) {}
      });

      var iframes = Array.prototype.slice.call(container.querySelectorAll('iframe'));

      iframes.forEach(function(iframe) {
        var src = iframe.getAttribute('src');

        if (src && src.indexOf('autoplay=1') > -1) {
          iframe.setAttribute(
            'src',
            src
              .replace('&autoplay=1&playsinline=1', '')
              .replace('?autoplay=1&playsinline=1', '')
              .replace('&autoplay=1', '')
              .replace('?autoplay=1', '')
          );

          iframe.dataset.projectAutoplayApplied = 'false';
        }
      });

      var containerPlayers = Array.prototype.slice.call(container.querySelectorAll('[data-project-player]'));

      containerPlayers.forEach(function(player) {
        player.classList.remove('is-playing');
      });
    }

    function applyFilter(filterName) {
      var visibleCount = 0;
      var isVideoMode = filterName === 'video';

      updateContentTitle(filterName);

      if (projectGrid) {
        projectGrid.hidden = isVideoMode;
      }

      if (videoGrid) {
        videoGrid.hidden = !isVideoMode;
      }

      if (isVideoMode) {
        cards.forEach(function(card) {
          card.hidden = true;
        });

        videoCards.forEach(function(videoCard) {
          videoCard.hidden = false;
          visibleCount += 1;
        });
      } else {
        pauseMediaInside(videoGrid);

        videoCards.forEach(function(videoCard) {
          videoCard.hidden = true;
        });

        cards.forEach(function(card) {
          var cardType = card.getAttribute('data-project-type');

          var visible =
            filterName === 'all' ||
            cardType === filterName;

          card.hidden = !visible;

          if (visible) {
            visibleCount += 1;
          }
        });
      }

      filters.forEach(function(button) {
        button.classList.toggle(
          'is-active',
          button.getAttribute('data-project-filter') === filterName
        );
      });

      if (emptyMessage) {
        emptyMessage.hidden = visibleCount !== 0;
      }
    }

    function addAutoplayToIframe(iframe) {
      if (!iframe) return;
      if (iframe.dataset.projectAutoplayApplied === 'true') return;

      var src = iframe.getAttribute('src');
      if (!src) return;

      var separator = src.indexOf('?') > -1 ? '&' : '?';
      iframe.setAttribute('src', src + separator + 'autoplay=1&playsinline=1');
      iframe.dataset.projectAutoplayApplied = 'true';
    }

    function pauseModalMedia(modal) {
      pauseMediaInside(modal);
    }

    function isAnyModalOpen() {
      return modals.some(function(modal) {
        return modal.hidden === false;
      });
    }

    function unlockScrollIfNeeded() {
      if (!isAnyModalOpen() && (!lightbox || lightbox.hidden === true)) {
        document.documentElement.style.overflow = '';
      }
    }

    function closeAllModals() {
      modals.forEach(function(modal) {
        pauseModalMedia(modal);
        modal.hidden = true;
      });

      unlockScrollIfNeeded();
    }

    function openModal(id) {
      var modal = root.querySelector('[data-project-modal="' + id + '"]');
      var closeButton = modal ? modal.querySelector('[data-project-close]') : null;

      if (!modal) return;

      closeAllModals();

      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      if (closeButton) {
        window.requestAnimationFrame(function() {
          closeButton.focus({ preventScroll: true });
        });
      }
    }

    function renderLightboxImage() {
      if (!lightboxImage || !currentGalleryImages.length) return;

      var imageUrl = currentGalleryImages[currentGalleryIndex];

      lightboxImage.src = imageUrl;
    }

    function openLightbox(imageUrl, galleryImages) {
      if (!lightbox || !lightboxImage || !imageUrl) return;

      currentGalleryImages = galleryImages && galleryImages.length ? galleryImages : [imageUrl];
      currentGalleryIndex = currentGalleryImages.indexOf(imageUrl);

      if (currentGalleryIndex < 0) {
        currentGalleryIndex = 0;
      }

      renderLightboxImage();

      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function showPreviousImage() {
      if (!currentGalleryImages.length) return;

      currentGalleryIndex = currentGalleryIndex - 1;

      if (currentGalleryIndex < 0) {
        currentGalleryIndex = currentGalleryImages.length - 1;
      }

      renderLightboxImage();
    }

    function showNextImage() {
      if (!currentGalleryImages.length) return;

      currentGalleryIndex = currentGalleryIndex + 1;

      if (currentGalleryIndex >= currentGalleryImages.length) {
        currentGalleryIndex = 0;
      }

      renderLightboxImage();
    }

    function closeLightbox() {
      if (!lightbox || !lightboxImage) return;

      lightbox.hidden = true;
      lightboxImage.src = '';
      currentGalleryImages = [];
      currentGalleryIndex = 0;

      unlockScrollIfNeeded();
    }

    players.forEach(function(player) {
      var cover = player.querySelector('[data-project-cover]');
      var nativeVideo = player.querySelector('video');
      var iframe = player.querySelector('iframe');

      if (cover) {
        cover.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();

          player.classList.add('is-playing');

          if (nativeVideo) {
            try {
              nativeVideo.play();
            } catch(error) {}
          }

          if (iframe) {
            addAutoplayToIframe(iframe);
          }
        });
      }

      if (nativeVideo) {
        nativeVideo.addEventListener('ended', function() {
          player.classList.remove('is-playing');

          try {
            nativeVideo.currentTime = 0;
          } catch(error) {}
        });
      }
    });

    filters.forEach(function(button) {
      button.addEventListener('click', function() {
        var filterName = button.getAttribute('data-project-filter') || 'all';
        applyFilter(filterName);
      });
    });

    openButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var modalId = button.getAttribute('data-project-open');
        openModal(modalId);
      });
    });

    closeButtons.forEach(function(button) {
      button.addEventListener('click', closeAllModals);
    });

    modals.forEach(function(modal) {
      modal.addEventListener('click', function(event) {
        if (event.target === modal) {
          closeAllModals();
        }
      });
    });

    imageButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var gallery = button.closest('.proyecto-experiencias__gallery');
        var galleryButtons = gallery
          ? Array.prototype.slice.call(gallery.querySelectorAll('[data-project-image]'))
          : imageButtons;

        var galleryImages = galleryButtons.map(function(item) {
          return item.getAttribute('data-project-image');
        }).filter(Boolean);

        openLightbox(button.getAttribute('data-project-image'), galleryImages);
      });
    });

    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', function(event) {
        event.stopPropagation();
        showPreviousImage();
      });
    }

    if (lightboxNext) {
      lightboxNext.addEventListener('click', function(event) {
        event.stopPropagation();
        showNextImage();
      });
    }

    if (lightbox) {
      lightbox.addEventListener('click', function(event) {
        if (event.target === lightbox) {
          closeLightbox();
        }
      });

      lightbox.addEventListener('touchstart', function(event) {
        if (!event.changedTouches || !event.changedTouches.length) return;
        touchStartX = event.changedTouches[0].screenX;
      }, { passive: true });

      lightbox.addEventListener('touchend', function(event) {
        if (!event.changedTouches || !event.changedTouches.length) return;

        touchEndX = event.changedTouches[0].screenX;

        if (Math.abs(touchEndX - touchStartX) < 45) return;

        if (touchEndX < touchStartX) {
          showNextImage();
        } else {
          showPreviousImage();
        }
      }, { passive: true });
    }

    document.addEventListener('keydown', function(event) {
      if (lightbox && lightbox.hidden === false) {
        if (event.key === 'Escape') {
          closeLightbox();
          return;
        }

        if (event.key === 'ArrowLeft') {
          showPreviousImage();
          return;
        }

        if (event.key === 'ArrowRight') {
          showNextImage();
          return;
        }
      }

      if (event.key === 'Escape') {
        closeAllModals();
      }
    });

    syncCountsAndFilters();
    applyFilter('all');
  }

  function initAllProyectoExperiencias() {
    var roots = document.querySelectorAll('.js-proyecto-experiencias');

    roots.forEach(function(root) {
      initProyectoExperiencias(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProyectoExperiencias);
  } else {
    initAllProyectoExperiencias();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.classList && event.target.classList.contains('js-proyecto-experiencias')
      ? event.target
      : event.target.querySelector('.js-proyecto-experiencias');

    if (root) {
      root.dataset.proyectoExperienciasInitialized = 'false';
      initProyectoExperiencias(root);
    }
  });
})();